export default {
  message: {
    Tour: {
      continue: "Kontine",
      back: "Dellu",
      finish: "Jeexal"
    },
    Login: {
      title: "Duggug waajur",
      sign_in: "Dugg",
      login_fail:
        "Saytu bi dafa lajj. Jéema ci benn yoon walla jokkoo ak sa daara ngir am ndimbal ci dugg bi.",
      forgot_password: "Fàtte nga sa baatu-jàll",
      create_account: "Sos sàq",
      password: "Baatu-jàll",
      confirm_password: "Dëggal baatu-jàll bi",
      password_reminder: "Fattaliku baatu-jàll",
      enter_email: "Dugal sa màkkaanu email",
      validation_error: "Bataaxalu njuumte ci saytu",
      password_reminder_error_no_user_register:
        "Turu jëfandikukat bi nga dugal gisuwul. Jéema ci benn yoon walla sos sàq bu bees.",
      password_reminder_error_no_user: "Turu jëfandikukat bi nga dugal gisuwul.",
      password_reminder_sent: "Email bu am yeneen tegtal yónne nañu ko ci {email}.",
      password_reminder_sent_message:
        "Email bi mën na jël ay simili ngir ñëw. Soo ko gisul ci sa boyet, seet ci sa dencukaay spam.",
      password_trouble_email: "Soo amee jafe-jafe, jokkoo ak {email}.",
      password_trouble_school:
        "Soo amee jafe-jafe, jokkoo ak sa daara ngir am ndimbal.",
      return_to_sign_in: "Dellu ci dugg",
      create_my_account: "Sos sama sàq",
      or_sign_in_with: "WALLA DUGG AK",
      password_reset: "Tànnal baatu-jàll bu bees ngir sa sàq.",
      password_reset_warning:
        "Soo ñaanul soppi sa baatu-jàll, jokkoo ak kilifa daara bi ci saasi.",
      password_update: "Tànn baatu-jàll bu bees",
      password_update_confirm: "Dëggal baatu-jàll bu bees bi",
      password_update_success: "Sa baatu-jàll bu bees bi denc nañu ko."
    },
    AccountSettings: {
      title: "Tëralini sàq",
      first_name: "Tur",
      last_name: "Sant",
      email: "Email",
      username: "Turu jëfandikukat",
      password: "Baatu-jàll",
      students: "Ndongo yi",
      teachers: "Jàngalekat yi",
      external_id: "ID bu biti",
      phone: "Nimero telefon",
      phone_required: "Nimero telefon dayo na",
      edit: "Soppi",
      remove: "Dindi",
      add: "Yokk",
      remove_message: "Ndax dëgg-dëgg nga bëgg dindi turu ndongo bii?",
      yes: "Waaw",
      no: "Déet",
      add_student: "Yokk ndongo",
      close: "Tëj",
      save: "Denc coppite yi",
      cancel: "Neenal",
      student_alert_message: "War nga dugal lu néew néew benn ndongo.",
      logout: "Génn"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    LeadStatus: {
      title: "Update Lead Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      reject: "Reject",
      updatedSuccess: "Lead status updated successfully",
      updateError: "Failed to update lead status",
      convertedNote: "This marks the lead as a customer. If a school exists, it may be set to active.",
      suppressedNote: "This suppresses the lead. You can restore it later from Suppressed.",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    WelcomeEmail: {
      title: "Send welcome email?",
      schoolLabel: "School",
      districtLabel: "District",
      contactLabel: "Contact",
      emailLabel: "Email",
      subdomainLabel: "Subdomain",
      usernameLabel: "Username",
      body: "PTC Wizard will email this account's admin-site credentials and documentation links.",
      confirm: "Send email",
      cancel: "Cancel",
      success: "Welcome email sent",
      error: "Failed to send welcome email",
      tooltip: "Send welcome email"
    },
    Navbar: {
      my_meetings: "Samay ndaje",
      language: "Wolof",
      help: "Ndimbal",
      account_settings: "Tëralini sàq",
      user_management: "User Management",
      logout: "Génn"
    },
    SubNavbar: {
      meeting: "Ndaje",
      event: "Xew-xew",
      print: "Móol",
      email: "Email",
      export: "Génne"
    },
    ConferenceCard: {
      add_edit_meetings: "Yokk/Soppi ndaje yi",
      opening: "Ubbite",
      closed: "Tëjoon"
    },
    Agenda: {
      full_agenda: "Ajanda bu mat sëkk",
      empty_state_title: "Gisuwuñu benn ndajeek sawar ngir yaw.",
      empty_state_message: "Soo amee laaj, jokkoo ak killu sa daara.",
      confirmation_modal_title: "Ajanda bi dëggal",
      confirmation_modal_message:
        "Sa ajanda dëggal nañu ko bu baax te yónne nañu la email.",
      complete_button: "Jeex na!"
    },
    AgendaCard: {
      room: "Néeg bi amul",
      room_with_value: "Néeg: {room}",
      virtual_meeting: "Ndaje ci internet",
      all_conferences: "Ndajeek yépp",
      conference: "Ndajeek",
      student: "Ndongo",
      meeting_with: "Ndaje ak",
      date_time: "Tarix/Waxtu",
      meeting_type: "Xeetu ndaje",
      location: "Barab",
      comment: "Kaddu",
      action: "Jëf",
      delete: "Far",
      add_comment: "Yokk kaddu",
      join: "Bokk ci ndaje bi",
      choose_meeting_type: "Tànn xeetu ndaje",
      in_person: "Ci kanam",
      phone: "Telefon",
      callback: "Wootelaat",
      virtual: "Ci internet",
      hybrid: "Hybrid",
      unavailable: "Amul",
      tooltip_translator:
        "Sarwiisu tekki du wóoradi wante daara bi dina jéema def lépp ngir mu am.",
      translator_requested: "Ñaan nañu tekkikat",
      clear_translator: "Far ñaanu tekkikat",
      need_translator: "Soxla nga tekkikat?",
      choose_language: "Tànn làkk"
    },
    ScheduleMatrix: {
      no_teachers_title: "Tànnul benn jàngalekat walla ekip.",
      no_teachers_message: "Tànnal jàngalekat ngir gis waxtu ndajem.",
      choose_teachers_button: "Wone jàngalekat walla ekip yi jëppale",
      choose_student: "Ngir ban ndongo?",
      cancel: "Neenal"
    },
    Matrix: {
      teachers: "Jàngalekat yi",
      agenda: "Saytu te kontine"
    },
    DrawerTeachers: {
      teachers: "Jàngalekat yi",
      name: "Tur",
      description: "Faramfacce",
      student: "Ndongo",
      teacher_team: "Jàngalekat/Ekip",
      show_more: "Wone yeneen jàngalekat",
      show_all: "Wone jàngalekat yépp ci daara bi",
      selected: "({count}) tànn",
      closeDrawer: "Kontine ci waxtaan",
      search: "Seet jàngalekat walla ekip",
      not_available: "Jàngalekat bii amul waxtu ndaje ci {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "Amoo benn ndaje bu nu waxtaan.",
      no_meetings_message: "Soo tànnee jàngalekat ak waxtu, dina feeñ fii.",
      new_meeting_label: "Bees",
      cancel_button: "Neenal",
      student_label: "Ndongo",
      meeting_type_location: "Xeetu ndaje/Barab",
      comment_label: "Kaddu",
      save_comment_button: "Denc kaddu bi",
      confirm_label: "Dëggal:",
      confirm_cancel_button: "Waaw, neenal sama ndaje ak ",
      do_not_cancel_button: "Bul neenal",
      confirm_agenda_button: "Dëggal ajanda bii",
      confirm_agenda_message_line1: "Mën nga dellu soppiku saa sañse.",
      confirm_agenda_message_line2: "Dina ñu la yónne sa ajanda ci email."
    },
    EmailConsent: {
      message:
        "Ngir aar sa sutura ak kaaraange, soxla nanu nga nangu ñu lay yónne xibaar ci sa màkkaanu email.",
      consent: "Nangu"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    },
    Events: {
      loadError: "Xew-xew yi jotuñu yebbu.",
      retry: "Jéemaat"
    }
  }
};
